<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">
        <span
          v-if="mData.viewMode == 'create'"
        >{{aLang.c_create}} phiếu thu thập dữ liệu sức khỏe cá nhân ban đầu</span>
        <span
          v-if="mData.viewMode == 'update'"
        >{{aLang.c_update}} phiếu thu thập dữ liệu sức khỏe cá nhân ban đầu</span>
        <span
          v-if="mData.viewMode == 'detail'"
        >{{aLang.c_detail}} phiếu thu thập dữ liệu sức khỏe cá nhân ban đầu</span>
        <div class="card-header-actions"></div>
      </div>
      <div class="card-body">
        <el-form
          :model="mData.dataForm"
          :rules="mData.validForm"
          ref="myForm"
          label-width="100%"
          label-position="top"
        >
          <b-row>
            <b-col md="12">
              <el-form-item label="Mã hộ gia đình" prop="ma_ho_gia_dinh">
                <el-input
                  type="text"
                  v-model="mData.dataForm.ma_ho_gia_dinh"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                ></el-input>
              </el-form-item>
            </b-col>
          </b-row>

          <b-row class="mt-2">
            <b-col md="12">
              <b-card>
                <div slot="header">
                  <b-link
                    class="card-header-action btn-minimize"
                    v-b-toggle.collapseTTHC
                    v-b-tooltip.hover
                    :title="aLang.c_toggle"
                  >
                    A. THÔNG TIN HÀNH CHÍNH
                    <div class="card-header-actions">
                      <i class="icon-arrow-up"></i>
                    </div>
                  </b-link>
                </div>

                <b-collapse id="collapseTTHC" visible>
                  <b-row>
                    <b-col md="8">
                      <el-form-item label="Họ và tên" prop="ho_va_ten">
                        <el-input
                          type="text"
                          v-model="mData.dataForm.ho_va_ten"
                          :disabled="mData.viewMode == 'detail'"
                          clearable
                        ></el-input>
                      </el-form-item>
                    </b-col>
                    <b-col md="4">
                      <el-form-item label="Quan hệ với chủ hộ" prop="quan_he_voi_chu_ho">
                        <el-input
                          type="text"
                          v-model="mData.dataForm.quan_he_voi_chu_ho"
                          :disabled="mData.viewMode == 'detail'"
                          clearable
                        ></el-input>
                      </el-form-item>
                    </b-col>
                    <b-col md="2">
                      <el-form-item label="Giới tính" prop="gioi_tinh">
                        <el-radio
                          v-model="mData.dataForm.gioi_tinh"
                          :disabled="mData.viewMode == 'detail'"
                          label="2"
                        >Nam</el-radio>
                        <el-radio
                          v-model="mData.dataForm.gioi_tinh"
                          :disabled="mData.viewMode == 'detail'"
                          style="margin-left: 10px;"
                          label="1"
                        >Nữ</el-radio>
                      </el-form-item>
                    </b-col>
                    <b-col md="4">
                      <el-form-item label="Ngày tháng năm sinh" prop="ngay_sinh">
                        <el-date-picker
                          v-model="mData.dataForm.ngay_sinh"
                          type="date"
                          placeholder="Chọn ngày"
                          format="dd/MM/yyyy"
                          :disabled="mData.viewMode == 'detail'"
                        ></el-date-picker>
                      </el-form-item>
                    </b-col>
                    <b-col md="6"></b-col>
                    <b-col md="6">
                      <el-form-item label="Số CMND/CCCD" prop="cmt">
                        <el-input
                          type="text"
                          v-model="mData.dataForm.cmt"
                          :disabled="mData.viewMode == 'detail'"
                          clearable
                        ></el-input>
                      </el-form-item>
                    </b-col>
                    <b-col md="3">
                      <el-form-item label="Ngày cấp" prop="ngay_cap">
                        <el-date-picker
                          v-model="mData.dataForm.ngay_cap"
                          type="date"
                          placeholder="Chọn ngày"
                          format="dd/MM/yyyy"
                          :disabled="mData.viewMode == 'detail'"
                        ></el-date-picker>
                      </el-form-item>
                    </b-col>
                    <b-col md="3">
                      <el-form-item label="Nơi cấp" prop="noi_cap">
                        <el-input
                          type="text"
                          v-model="mData.dataForm.noi_cap"
                          :disabled="mData.viewMode == 'detail'"
                          clearable
                        ></el-input>
                      </el-form-item>
                    </b-col>
                    <b-col md="12">
                      <el-form-item label="Mã Số Bảo hiểm y tế" prop="ma_bhyt">
                        <el-input
                          type="text"
                          v-model="mData.dataForm.ma_bhyt"
                          :disabled="mData.viewMode == 'detail'"
                          clearable
                        ></el-input>
                      </el-form-item>
                    </b-col>
                    <b-col md="12">
                      <el-form-item
                        label="Nơi đăng ký hộ khẩu thường trú (Thôn/xóm; số nhà, đường phố)"
                        prop="ho_khau_thuong_tru"
                      >
                        <el-input
                          type="text"
                          v-model="mData.dataForm.ho_khau_thuong_tru"
                          :disabled="mData.viewMode == 'detail'"
                          clearable
                        ></el-input>
                      </el-form-item>
                    </b-col>
                    <b-col md="4">
                      <el-form-item label="Tỉnh/TP" prop="tinh_thuong_tru">
                        <el-select
                          v-model="mData.dataForm.tinh_thuong_tru"
                          filterable
                          :disabled="mData.viewMode == 'detail'"
                          @change="fn_changeProvince('thuong_tru')"
                        >
                          <el-option
                            v-for="item in mData.dataDefault.listProvince"
                            :key="item.MA_TINH"
                            :label="item.TEN_TINH"
                            :value="item.MA_TINH"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </b-col>
                    <b-col md="4">
                      <el-form-item label="Quận/Huyện" prop="quan_huyen_thuong_tru">
                        <el-select
                          v-model="mData.dataForm.quan_huyen_thuong_tru"
                          filterable
                          :disabled="mData.viewMode == 'detail'"
                          @change="fn_changeDistrict('thuong_tru')"
                        >
                          <el-option
                            v-for="item in mData.dataDefault.district_thuong_tru"
                            :key="item.MA_QUAN"
                            :label="item.TEN_QUAN"
                            :value="item.MA_QUAN"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </b-col>
                    <b-col md="4">
                      <el-form-item label="Xã/Phường" prop="xa_phuong_thuong_tru">
                        <el-select
                          v-model="mData.dataForm.xa_phuong_thuong_tru"
                          filterable
                          :disabled="mData.viewMode == 'detail'"
                        >
                          <el-option
                            v-for="item in mData.dataDefault.communce_thuong_tru"
                            :key="item.MA_XA"
                            :label="item.TEN_XA"
                            :value="item.MA_XA"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </b-col>
                    <b-col md="12">
                      <el-form-item
                        label="Nơi ở hiện tại: Thôn/xóm; số nhà, đường phố"
                        prop="noi_o_hien_tai"
                      >
                        <el-input
                          type="text"
                          v-model="mData.dataForm.noi_o_hien_tai"
                          :disabled="mData.viewMode == 'detail'"
                          clearable
                        ></el-input>
                      </el-form-item>
                    </b-col>
                    <b-col md="4">
                      <el-form-item label="Tỉnh/TP" prop="tinh_hien_tai">
                        <el-select
                          v-model="mData.dataForm.tinh_hien_tai"
                          filterable
                          :disabled="mData.viewMode == 'detail'"
                          @change="fn_changeProvince('hien_tai')"
                        >
                          <el-option
                            v-for="item in mData.dataDefault.listProvince"
                            :key="item.MA_TINH"
                            :label="item.TEN_TINH"
                            :value="item.MA_TINH"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </b-col>
                    <b-col md="4">
                      <el-form-item label="Quận/Huyện" prop="quan_huyen_hien_tai">
                        <el-select
                          v-model="mData.dataForm.quan_huyen_hien_tai"
                          filterable
                          :disabled="mData.viewMode == 'detail'"
                          @change="fn_changeDistrict('hien_tai')"
                        >
                          <el-option
                            v-for="item in mData.dataDefault.district_hien_tai"
                            :key="item.MA_QUAN"
                            :label="item.TEN_QUAN"
                            :value="item.MA_QUAN"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </b-col>
                    <b-col md="4">
                      <el-form-item label="Xã/Phường" prop="xa_phuong_hien_tai">
                        <el-select
                          v-model="mData.dataForm.xa_phuong_hien_tai"
                          filterable
                          :disabled="mData.viewMode == 'detail'"
                        >
                          <el-option
                            v-for="item in mData.dataDefault.communce_hien_tai"
                            :key="item.MA_XA"
                            :label="item.TEN_XA"
                            :value="item.MA_XA"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </b-col>
                    <b-col md="4">
                      <el-form-item label="Điện thoại cố định" prop="dien_thoai_co_dinh">
                        <el-input
                          type="text"
                          v-model="mData.dataForm.dien_thoai_co_dinh"
                          :disabled="mData.viewMode == 'detail'"
                          clearable
                        ></el-input>
                      </el-form-item>
                    </b-col>
                    <b-col md="4">
                      <el-form-item label="Di động" prop="dien_thoai_di_dong">
                        <el-input
                          type="text"
                          v-model="mData.dataForm.dien_thoai_di_dong"
                          :disabled="mData.viewMode == 'detail'"
                          clearable
                        ></el-input>
                      </el-form-item>
                    </b-col>
                    <b-col md="4">
                      <el-form-item label="Email" prop="email">
                        <el-input
                          type="text"
                          v-model="mData.dataForm.email"
                          :disabled="mData.viewMode == 'detail'"
                          clearable
                        ></el-input>
                      </el-form-item>
                    </b-col>
                    <b-col md="12">
                      <p
                        style="font-style: italic; font-weight: 700"
                      >Trường hợp trẻ dưới 18 tuổi, bổ sung thông tin:</p>
                    </b-col>
                    <b-col md="4">
                      <el-form-item label="Họ tên bố" prop="ho_ten_bo">
                        <el-input
                          type="text"
                          v-model="mData.dataForm.ho_ten_bo"
                          :disabled="mData.viewMode == 'detail'"
                          clearable
                        ></el-input>
                      </el-form-item>
                    </b-col>
                    <b-col md="4">
                      <el-form-item label="Điện thoại cố định" prop="dien_thoai_co_dinh_bo">
                        <el-input
                          type="text"
                          v-model="mData.dataForm.dien_thoai_co_dinh_bo"
                          :disabled="mData.viewMode == 'detail'"
                          clearable
                        ></el-input>
                      </el-form-item>
                    </b-col>
                    <b-col md="4">
                      <el-form-item label="Di động" prop="dien_thoai_di_dong_bo">
                        <el-input
                          type="text"
                          v-model="mData.dataForm.dien_thoai_di_dong_bo"
                          :disabled="mData.viewMode == 'detail'"
                          clearable
                        ></el-input>
                      </el-form-item>
                    </b-col>
                    <b-col md="4">
                      <el-form-item label="Họ tên mẹ" prop="ho_ten_me">
                        <el-input
                          type="text"
                          v-model="mData.dataForm.ho_ten_me"
                          :disabled="mData.viewMode == 'detail'"
                          clearable
                        ></el-input>
                      </el-form-item>
                    </b-col>
                    <b-col md="4">
                      <el-form-item label="Điện thoại cố định" prop="dien_thoai_co_dinh_me">
                        <el-input
                          type="text"
                          v-model="mData.dataForm.dien_thoai_co_dinh_me"
                          :disabled="mData.viewMode == 'detail'"
                          clearable
                        ></el-input>
                      </el-form-item>
                    </b-col>
                    <b-col md="4">
                      <el-form-item label="Di động" prop="dien_thoai_di_dong_me">
                        <el-input
                          type="text"
                          v-model="mData.dataForm.dien_thoai_di_dong_me"
                          :disabled="mData.viewMode == 'detail'"
                          clearable
                        ></el-input>
                      </el-form-item>
                    </b-col>
                    <b-col md="12">
                      <p
                        style="font-style: italic; font-weight: 700"
                      >Trường hợp trẻ dưới 18 tuổi không ở cùng bố mẹ, bổ sung thông tin:</p>
                    </b-col>
                    <b-col md="8">
                      <el-form-item
                        label="Họ tên người chăm sóc chính"
                        prop="ho_ten_nguoi_cham_soc"
                      >
                        <el-input
                          type="text"
                          v-model="mData.dataForm.ho_ten_nguoi_cham_soc"
                          :disabled="mData.viewMode == 'detail'"
                          clearable
                        ></el-input>
                      </el-form-item>
                    </b-col>
                    <b-col md="4">
                      <el-form-item label="Mối quan hệ" prop="moi_quan_he">
                        <el-input
                          type="text"
                          v-model="mData.dataForm.moi_quan_he"
                          :disabled="mData.viewMode == 'detail'"
                          clearable
                        ></el-input>
                      </el-form-item>
                    </b-col>
                    <b-col md="6">
                      <el-form-item
                        label="Điện thoại cố định"
                        prop="dien_thoai_co_dinh_nguoi_cham_soc"
                      >
                        <el-input
                          type="text"
                          v-model="mData.dataForm.dien_thoai_co_dinh_nguoi_cham_soc"
                          :disabled="mData.viewMode == 'detail'"
                          clearable
                        ></el-input>
                      </el-form-item>
                    </b-col>
                    <b-col md="6">
                      <el-form-item label="Di động" prop="dien_thoai_di_dong_nguoi_cham_soc">
                        <el-input
                          type="text"
                          v-model="mData.dataForm.dien_thoai_di_dong_nguoi_cham_soc"
                          :disabled="mData.viewMode == 'detail'"
                          clearable
                        ></el-input>
                      </el-form-item>
                    </b-col>
                  </b-row>
                </b-collapse>
              </b-card>
            </b-col>
          </b-row>
          <b-row class="mt-2">
            <b-col md="12">
              <b-card>
                <div slot="header">
                  <b-link
                    class="card-header-action btn-minimize"
                    v-b-toggle.collapseCSSKCB
                    v-b-tooltip.hover
                    :title="aLang.c_toggle"
                  >
                    B. CHỈ SỐ SỨC KHỎE CƠ BẢN
                    <div class="card-header-actions">
                      <i class="icon-arrow-up"></i>
                    </div>
                  </b-link>
                </div>

                <b-collapse id="collapseCSSKCB" visible>
                  <b-row>
                    <b-col md="6">
                      <el-form-item label="Ngày thu thập" prop="ngay_thu_thap">
                        <el-date-picker
                          v-model="mData.dataForm.ngay_thu_thap"
                          type="date"
                          placeholder="Chọn ngày"
                          format="dd/MM/yyyy"
                          :disabled="mData.viewMode == 'detail'"
                        ></el-date-picker>
                      </el-form-item>
                    </b-col>
                    <b-col md="6"></b-col>
                    <b-col md="6">
                      <el-form-item label="Cân nặng (kg)" prop="can_nang">
                        <el-input-number
                          v-model="mData.dataForm.can_nang"
                          :precision="1"
                          :step="1"
                          :min="0"
                          :disabled="mData.viewMode == 'detail'"
                          placeholder="Nhập cân nặng"
                        ></el-input-number>
                      </el-form-item>
                    </b-col>
                    <b-col md="6">
                      <el-form-item label="Chiều cao (cm)" prop="chieu_cao">
                        <el-input-number
                          v-model="mData.dataForm.chieu_cao"
                          :precision="1"
                          :step="1"
                          :min="0"
                          :disabled="mData.viewMode == 'detail'"
                          placeholder="Nhập chiều cao"
                        ></el-input-number>
                      </el-form-item>
                    </b-col>
                    <b-col md="6">
                      <el-form-item label="Vòng bụng (cm)" prop="vong_bung">
                        <el-input-number
                          v-model="mData.dataForm.vong_bung"
                          :precision="1"
                          :step="1"
                          :min="0"
                          :disabled="mData.viewMode == 'detail'"
                          placeholder="Nhập số đo vòng bụng"
                        ></el-input-number>
                      </el-form-item>
                    </b-col>
                    <b-col md="6">
                      <el-form-item label="Huyết áp (mmHg)" prop="huyet_ap">
                        <el-input
                          type="text"
                          v-model="mData.dataForm.huyet_ap"
                          :disabled="mData.viewMode == 'detail'"
                          placeholder="Huyết áp tối đa /Huyết áp tối thiểu"
                          clearable
                        ></el-input>
                      </el-form-item>
                    </b-col>
                    <b-col md="12">
                      <el-form-item
                        label="Nhóm máu (đã được bệnh viện xác định chính xác)"
                        prop="nhom_mau"
                      >
                        <el-checkbox-group v-model="mData.dataDefault.nhom_mau" :max="1">
                          <el-checkbox label="A" :disabled="mData.viewMode == 'detail'"></el-checkbox>
                          <el-checkbox label="B" :disabled="mData.viewMode == 'detail'"></el-checkbox>
                          <el-checkbox label="AB" :disabled="mData.viewMode == 'detail'"></el-checkbox>
                          <el-checkbox label="O" :disabled="mData.viewMode == 'detail'"></el-checkbox>
                        </el-checkbox-group>
                      </el-form-item>
                    </b-col>
                    <b-col md="12">
                      <el-table border :data="mData.dataDefault.tableData" style="width: 100%">
                        <el-table-column
                          prop="diseases"
                          label="Bệnh tật đã mắc (theo chẩn đoán của bệnh viện)"
                          align="center"
                        >
                          <template slot="header">
                            Bệnh tật đã mắc
                            <i
                              style="font-weight: normal;"
                            >(theo chẩn đoán của bệnh viện)</i>
                          </template>
                        </el-table-column>
                        <el-table-column label="Có" width="180" align="center">
                          <template slot-scope="scope">
                            <div style="position: relative; width: 40; height: 40;">
                              <el-checkbox
                                v-model="scope.row.yes"
                                :disabled="mData.viewMode == 'detail'"
                                @change="fn_changeSelect(scope.row,'yes')"
                              ></el-checkbox>
                            </div>
                          </template>
                        </el-table-column>
                        <el-table-column label="Không" width="180" align="center">
                          <template slot-scope="scope">
                            <div>
                              <el-checkbox
                                v-model="scope.row.no"
                                :disabled="mData.viewMode == 'detail'"
                                @change="fn_changeSelect(scope.row,'no')"
                              ></el-checkbox>
                            </div>
                          </template>
                        </el-table-column>
                      </el-table>
                    </b-col>
                  </b-row>
                </b-collapse>
              </b-card>
            </b-col>
          </b-row>
          <b-row class="mt-2">
            <b-col md="6">
              <p
                style="font-weight: 700; text-align: center; margin-bottom: 10px;"
              >Người cung cấp thông tin</p>
              <p
                style="font-style: italic; text-align: center;"
              >(Thành viên hộ gia đình ký và ghi rõ họ tên)</p>
              <!-- <div style="max-width: 300px; margin: auto;">
                  <el-form-item prop="nguoi_cung_cap_thong_tin">
                <el-input v-model="mData.dataForm.nguoi_cung_cap_thong_tin"></el-input>
              </el-form-item>
              </div>-->
            </b-col>
            <b-col md="6">
              <p
                style="font-weight: 700; text-align: center; margin-bottom: 10px;"
              >Người tiếp nhận phiếu</p>
              <p
                style="font-style: italic; text-align: center;"
              >(CTV, Tổ trưởng, cán bộ Phường/ Xã…)</p>
              <!-- <div style="max-width: 300px; margin: auto;">
                    <el-form-item prop="nguoi_tiep_nhan_phieu">
                    <el-input v-model="mData.dataForm.nguoi_tiep_nhan_phieu"></el-input>
                    </el-form-item>
              </div>-->
            </b-col>
          </b-row>
          <el-form-item class="text-center mt-3">
            <el-button
              type="info"
              plain
              @click="fn_submitForm('create')"
              v-ladda
              v-if="mData.viewMode == 'create'"
            >{{aLang.c_create}}</el-button>

            <el-button
              type="info"
              plain
              @click="fn_submitForm('update')"
              v-ladda
              v-if="mData.viewMode == 'update'"
            >{{aLang.c_update}}</el-button>

            <el-button @click="fn_go()" type="info" plain>{{aLang.c_back}}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageService from "../../../service/LanguageService";
import DataService from "../../../service/DataService";
import MethodService from "../../../service/MethodService";
import ExtensionService from "../../../service/ExtensionService";
import Hssk831Api from "../../../moduleApi/Hssk831Api";
import KhaoSatApi from "../../../moduleApi/KhaoSatApi";
import SucKhoeCaNhanModel from "./SucKhoeCaNhanModel";
import moment from "moment";

export default {
  //   components: {
  //     EditorComponent
  //   },
  data() {
    return {
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      mData: {
        viewMode: "create",
        moduleName: "SucKhoeCaNhan",
        dataDefault: {
          roles: DataService.rolesInForm,
          listProvince: [],
          district_thuong_tru: [],
          district_hien_tai: [],
          communce_thuong_tru: [],
          communce_hien_tai: [],
          nhom_mau: [],
          tableData: [
            { diseases: "Tăng huyết áp", yes: null, no: null },
            { diseases: "Đái tháo đường", yes: null, no: null },
          ],
          listBenh: [],
        },
        dataForm: MethodService.copyObject(SucKhoeCaNhanModel.dataForm),
        validForm: SucKhoeCaNhanModel.validForm,
      },
    };
  },
  methods: {
    fn_submitForm(type) {
      this.$refs["myForm"].validate(async (valid) => {
        if (valid) {
          let currentUserBS = MethodService.getCurrentUserBS();
          let dataBody = {
            MA_HOGD: this.mData.dataForm.ma_ho_gia_dinh,
            HO_TEN: this.mData.dataForm.ho_va_ten.toUpperCase(),
            NGAY_SINH: parseInt(
              moment(this.mData.dataForm.ngay_sinh, "DD/MM/YYYY").format("DD")
            ),
            THANG_SINH: parseInt(
              moment(this.mData.dataForm.ngay_sinh, "DD/MM/YYYY").format("MM")
            ),
            NAM_SINH: parseInt(
              moment(this.mData.dataForm.ngay_sinh, "DD/MM/YYYY").format("YYYY")
            ),
            GIOI_TINH: this.mData.dataForm.gioi_tinh,
            DIA_CHI: this.mData.dataForm.noi_o_hien_tai,
            DIA_CHI_DKTT: this.mData.dataForm.ho_khau_thuong_tru,
            MA_TINH: this.mData.dataForm.tinh_thuong_tru,
            MA_HUYEN: this.mData.dataForm.quan_huyen_thuong_tru,
            MA_XA: this.mData.dataForm.xa_phuong_thuong_tru,
            NOI_O_MA_TINH: this.mData.dataForm.tinh_hien_tai,
            NOI_O_MA_HUYEN: this.mData.dataForm.quan_huyen_hien_tai,
            NOI_O_MA_XA: this.mData.dataForm.xa_phuong_hien_tai,
            CMND: this.mData.dataForm.cmt,
            NGAY_CAP: this.mData.dataForm.ngay_cap
              ? moment(this.mData.dataForm.ngay_cap).format("DD/MM/YYYY")
              : "",
            NOI_CAP: this.mData.dataForm.noi_cap,
            NHOM_MAU:
              this.mData.dataDefault.nhom_mau.length > 0
                ? this.mData.dataDefault.nhom_mau[0]
                : "",
            DIEN_THOAI: this.mData.dataForm.dien_thoai_co_dinh,
            DIEN_THOAI_DD: this.mData.dataForm.dien_thoai_di_dong,
            EMAIL: this.mData.dataForm.email,
            HO_TEN_NCSC: this.mData.dataForm.ho_ten_nguoi_cham_soc,
            HO_TEN_BO: this.mData.dataForm.ho_ten_bo,
            HO_TEN_ME: this.mData.dataForm.ho_ten_me,
            MOI_QH_CH: this.mData.dataForm.quan_he_voi_chu_ho,
            MOI_QH_NCSC: this.mData.dataForm.moi_quan_he,
            DIEN_THOAI_NCSC: this.mData.dataForm
              .dien_thoai_co_dinh_nguoi_cham_soc,
            DIEN_THOAI_DD_NCSC: this.mData.dataForm
              .dien_thoai_di_dong_nguoi_cham_soc,
            CreateDate: moment().format("DD/MM/YYYY"),
            CreateBy: currentUserBS.UserName,
            dienthoai_bo: this.mData.dataForm.dien_thoai_co_dinh_bo,
            dienthoai_dd_bo: this.mData.dataForm.dien_thoai_di_dong_bo,
            dienthoai_me: this.mData.dataForm.dien_thoai_co_dinh_me,
            dienthoai_dd_me: this.mData.dataForm.dien_thoai_di_dong_me,
            cannang: this.mData.dataForm.can_nang,
            chieucao: this.mData.dataForm.chieu_cao,
            vongbung: this.mData.dataForm.vong_bung,
            huyetap: this.mData.dataForm.huyet_ap,
            ngaycapnhat: this.mData.dataForm.ngay_thu_thap
              ? moment(this.mData.dataForm.ngay_thu_thap).format("DD/MM/YYYY")
              : "",
          };
          try {
            let res = await KhaoSatApi.updateHSSKCN(dataBody);
            if (res.data && res.data.HSSK_Id) {
              let huyet_ap;
              let dai_duong;
              this.mData.dataDefault.tableData.forEach((item) => {
                if (item.name == "Tăng huyết áp") {
                  huyet_ap = item.yes ? item.yes : false;
                }
                if (item.name == "Đái tháo đường") {
                  dai_duong = item.yes ? item.yes : false;
                }
              });
              let dataBenhTat = [];
              this.mData.dataDefault.listBenh.forEach((item) => {
                if (item.code == "TangHuyetAp") {
                  dataBenhTat.push({
                    HSSK_Id: res.data.HSSK_Id,
                    LBENH_CN_Id: item.id,
                    MOTA: "",
                    MAC_BENH: huyet_ap,
                  });
                }
                if (item.code == "Daiduong") {
                  dataBenhTat.push({
                    HSSK_Id: res.data.HSSK_Id,
                    LBENH_CN_Id: item.id,
                    MOTA: "",
                    MAC_BENH: dai_duong,
                  });
                }
              });
              let resBenh = await KhaoSatApi.SaveHSSK_BENHTAT(dataBenhTat);
              toastr.success(this.aLang.c_addSuccess);
              this.fn_resetForm();
            }
          } catch (er) {
            return false;
          }
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },
    fn_resetForm() {
      this.$refs["myForm"].resetFields();
      this.mData.dataDefault.nhom_mau = [];
      this.mData.dataDefault.tableData = [
        { diseases: "Tăng huyết áp", yes: null, no: null },
        { diseases: "Đái tháo đường", yes: null, no: null },
      ];
      this.mData.dataForm.gioi_tinh = "2";
    },
    fn_go() {
      this.$router.go(-1);
    },
    async fn_getDataById(id) {
      let req = await KhaoSatApi.GetHoSo831ByHSSKCN_ID(id);
      let res = await req;
      // console.log(moment(new Date(res.data.NAM_SINH,res.data.THANG_SINH,res.data.NGAY_SINH)).format('DD/MM/YYYY'));
      if (res.data && res.data.length > 0) {
        let data = res.data[0].ThongTinHanhChinh;
        // console.log(data);
        this.mData.dataForm = {
          ma_ho_gia_dinh: data.MA_HOGD,
          ho_va_ten: data.HO_TEN,
          quan_he_voi_chu_ho: data.MOI_QH_CH,
          gioi_tinh: data.GIOI_TINH.toString(),
          ngay_sinh: new Date(
            data.namSinh,
            data.thangSinh - 1,
            data.ngaySinh
          ).toString("dd/MM/yyyy"),
          cmt: data.CMND,
          ngay_cap: moment(data.NGAY_CAP).format("DD/MM/YYYY"),
          noi_cap: data.NOI_CAP,
          ma_bhyt: data.SOTHEBHYT,
          ho_khau_thuong_tru: data.DIA_CHI_DKTT,
          xa_phuong_thuong_tru: data.MA_PHUONG_XA,
          quan_huyen_thuong_tru: data.MA_QUAN_HUYEN,
          tinh_thuong_tru: data.MA_TINH_THANH,
          noi_o_hien_tai: data.DIA_CHI,
          xa_phuong_hien_tai: data.NOI_O_MA_PHUONG_XA,
          quan_huyen_hien_tai: data.NOI_O_MA_QUAN_HUYEN,
          tinh_hien_tai: data.NOI_O_MA_TINH_THANH,
          dien_thoai_co_dinh: data.DIEN_THOAI,
          dien_thoai_di_dong: data.DIEN_THOAI_DD,
          email: data.EMAIL,
          ho_ten_bo: data.HO_TEN_BO,
          dien_thoai_co_dinh_bo: data.dienthoai_bo,
          dien_thoai_di_dong_bo: data.dienthoai_dd_bo,
          ho_ten_me: data.HO_TEN_ME,
          dien_thoai_co_dinh_me: data.dienthoai_me,
          dien_thoai_di_dong_me: data.dienthoai_dd_me,
          ho_ten_nguoi_cham_soc: data.HO_TEN_NCSC,
          moi_quan_he: data.MOI_QH_NCSC,
          dien_thoai_co_dinh_nguoi_cham_soc: data.DIEN_THOAI_NCSC,
          dien_thoai_di_dong_nguoi_cham_soc: data.DIEN_THOAI_DD_NCSC,
          ngay_thu_thap: data.ngaycapnhat,
          can_nang: data.cannang,
          chieu_cao: data.chieucao,
          vong_bung: data.vongbung,
          huyet_ap: data.huyetap,
        };
        if (data.NHOM_MAU) {
          this.mData.dataDefault.nhom_mau.push(data.NHOM_MAU);
        }
        this.mData.dataDefault.tableData.map((item) => {
          if (item.diseases == "Tăng huyết áp") {
            item.yes = data.B3_BenhTangHuyetAp;
            item.no = !data.B3_BenhTangHuyetAp;
          }
          if (item.diseases == "Đái tháo đường") {
            item.yes = data.B3_BenhDaiDuong;
            item.no = !data.B3_BenhDaiDuong;
          }
        });
        // console.log(this.mData.dataForm);
      }
    },
    async getDistrict() {
      let req = await Hssk831Api.LoadDMTinhThanh();
      let res = await req;
      console.log(res);
      if (res.data) {
        this.mData.dataDefault.listProvince = res.data;
      } else {
        this.mData.dataDefault.listProvince = [];
      }
    },
    async getBenhTat() {
      let req = await Hssk831Api.getBenhTat();
      let res = await req;
      console.log(res);
      if (res.result) {
        this.mData.dataDefault.listBenh = res.result;
      } else {
        this.mData.dataDefault.listBenh = [];
      }
    },
    async fn_initDataDefault() {
      this.getDistrict();
      this.getBenhTat();
    },

    fn_changeSelect(data, action) {
      if (data.yes != null && data.no != null) {
        if (action == "yes") {
          data.no = !data.no;
        } else {
          data.yes = !data.yes;
        }
      } else {
        if (action == "yes") {
          data.yes = true;
          data.no = false;
        } else {
          data.yes = false;
          data.no = true;
        }
        console.log("2", data);
      }
    },
    async fn_changeProvince(field, detail) {
      if (!detail) {
        this.mData.dataForm["quan_huyen_" + field] = "";
        this.mData.dataForm["xa_phuong_" + field] = "";
      }
      let reqDistrict = await Hssk831Api.LoadDMQuanHuyen(
        this.mData.dataForm["tinh_" + field]
      );
      let resDistrict = await reqDistrict;
      if (resDistrict.data && resDistrict.data.length > 0) {
        this.mData.dataDefault["district_" + field] = resDistrict.data;
      } else {
        this.mData.dataDefault["district_" + field] = [];
      }
    },
    async fn_changeDistrict(field, detail) {
      if (!detail) {
        this.mData.dataForm["xa_phuong_" + field] = "";
      }
      let reqCommunce = await Hssk831Api.LoadDMPhuongXa(
        this.mData.dataForm["tinh_" + field],
        this.mData.dataForm["quan_huyen_" + field]
      );
      let resCommunce = await reqCommunce;
      if (resCommunce.data && resCommunce.data.length > 0) {
        this.mData.dataDefault["communce_" + field] = resCommunce.data;
      } else {
        this.mData.dataDefault["communce_" + field] = [];
      }
    },
  },
  created: async function () {
    this.fn_initDataDefault();
    console.log(this.$router.currentRoute.name);
    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-update"
    ) {
      this.mData.viewMode = "update";
    }
    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-detail"
    ) {
      this.mData.viewMode = "detail";
    }
    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-create"
    ) {
      this.mData.viewMode = "create";
    }
    if (this.$router.currentRoute.params.id) {
      await this.fn_getDataById(this.$router.currentRoute.params.id);
      await this.fn_changeProvince("thuong_tru", true);
      await this.fn_changeProvince("hien_tai", true);
      await this.fn_changeDistrict("thuong_tru", true);
      await this.fn_changeDistrict("hien_tai", true);
    }
  },
  mounted: function () {},
};
</script>
<style lang="scss" scoped>
::v-deep .el-checkbox__inner {
  width: 18px !important;
}
</style>